import React, { useEffect, useState } from "react";
import { PieChart, Pie, Cell, Tooltip, Legend } from "recharts";

const VoterPieChart = ({ genderData, ageData, totalVotersList }) => {
  const GENDER_COLORS = ["#4B77BE", "#F39C12"]; // Better contrasting gender colors
  const AGE_COLORS = ["#9B59B6", "#3498DB", "#E74C3C", "#1ABC9C", "#F1C40F"]; // Vibrant age group colors

  return (
    <div
      style={{
        padding: "20px",
        backgroundColor: "#F4F6F9",
        borderRadius: "8px",
        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
      }}
    >
      <h3 style={{ color: "#333", marginBottom: "30px" }}>
        Total Voters: {totalVotersList}
      </h3>

      {/* Container for both charts side by side */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          gap: "30px",
          flexWrap: "wrap", // Ensures responsiveness (wraps charts on smaller screens)
          marginTop: "20px",
        }}
      >
        {/* Gender Distribution Pie Chart */}
        <div
          style={{
            width: "45%",
            minWidth: "300px",
            textAlign: "center",
            backgroundColor: "#fff",
            padding: "20px",
            borderRadius: "10px",
            boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
            marginBottom: "20px", // For better spacing on smaller screens
            display: "flex",
            flexDirection: "column",
            alignItems: "center", // Centering the chart horizontally
            justifyContent: "center", // Centering the chart vertically
          }}
        >
          <h4
            style={{
              fontSize: "20px",
              fontWeight: "bold",
              color: "#2C3E50",
              marginBottom: "20px",
            }}
          >
            Gender Distribution
          </h4>
          <PieChart width={350} height={350}>
            <Pie
              data={genderData}
              dataKey="value"
              nameKey="name"
              cx="50%"
              cy="50%"
              outerRadius={100}
              fill="#8884d8"
              label={({ name, value }) => `${value.toFixed(2)}%`}
            >
              {genderData?.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={GENDER_COLORS[index % GENDER_COLORS.length]}
                />
              ))}
            </Pie>
            <Tooltip formatter={(value) => `${value.toFixed(2)}%`} />
            <Legend verticalAlign="top" height={36} />
          </PieChart>
        </div>

        {/* Age Group Distribution Pie Chart */}
        <div
          style={{
            width: "45%",
            minWidth: "300px",
            textAlign: "center",
            backgroundColor: "#fff",
            padding: "20px",
            borderRadius: "10px",
            boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center", // Centering the chart horizontally
            justifyContent: "center", // Centering the chart vertically
          }}
        >
          <h4
            style={{
              fontSize: "20px",
              fontWeight: "bold",
              color: "#2C3E50",
              marginBottom: "20px",
            }}
          >
            Age Group Distribution
          </h4>
          <PieChart width={350} height={350}>
            <Pie
              data={ageData}
              dataKey="value"
              nameKey="name"
              cx="50%"
              cy="50%"
              outerRadius={100}
              fill="#8884d8"
              label={({ name, value }) => `${value.toFixed(2)}%`}
            >
              {ageData?.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={AGE_COLORS[index % AGE_COLORS.length]}
                />
              ))}
            </Pie>
            <Tooltip formatter={(value) => `${value.toFixed(2)}%`} />
            <Legend verticalAlign="top" height={36} />
          </PieChart>
        </div>
      </div>
    </div>
  );
};

export default VoterPieChart;
